module.exports = __webpack_public_path__ + "static/media/Dell XPS 15\".dfb690e0.png";